import React from 'react'
import { IconButton, styled } from '@mui/material'

export const HeaderWrapper = styled('div')({
  position: 'relative',
})

export const FullScreenExit = styled(IconButton)({
  position: 'absolute',
  top: -18,
  right: -48
})
